import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx } from "vue"

import { computed, ref, watch, PropType, onMounted } from "vue";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import { PropertyListingRoomResponse } from "@/types/properties/ai/PropertyListingRoomResponse";
import FieldValidationFreeTextArea from "@/components/ui/inputs/field-validation-free-text-area.vue";
import FieldValidationFreeTextbox from "@/components/ui/inputs/field-validation-free-textbox.vue";
import { SystemConfiguration } from "acquaint-api/constants/SystemConfiguration";
import { useSystemConfigurationStore } from "@/stores/SystemConfigurationStore";
import EditRoomMeasurements from "@/components/properties/record/edit-room-measurements.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'edit-property-listing-room',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * The room data to be edited.
   * @type {PropertyListingRoomResponse}
   * @required
   */
  room: {
    type: Object as PropType<PropertyListingRoomResponse>,
    required: true,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
  /**
   * The is emitted when the modal is closed so the parent component can refelct the new data.
   */
  "modalClosed",
],
  setup(__props, { emit }) {

const props = __props;




const displayCancelConfirmationModal = ref(false);
const keepingModalOpening = ref(false);
const saving = ref(false);
const editableData = ref<PropertyListingRoomResponse>({
  id: 0,
  name: "",
  description: "",
  length: 0,
  width: 0,
});
const systemConfigurationStore = useSystemConfigurationStore();
const configMeasurementType = ref("");
const formatMeasurements = ref(0);

const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const onCancelClick = () => (showModal.value = false);

onMounted(async () => {
  configMeasurementType.value =
    await systemConfigurationStore.getSystemConfigurationValue(
      SystemConfiguration.PropertyMeasurementUnits,
    );
});

watch(
  () => showModal.value,
  () => {
    if (!showModal.value || keepingModalOpening.value) {
      return;
    }
    editableData.value = JSON.parse(JSON.stringify(props.room));
    formatMeasurements.value++;
  },
);

watch(
  () => editableData.value,
  () => {
    displayCancelConfirmationModal.value =
      JSON.stringify(editableData.value) != JSON.stringify(props.room);
  },
  { deep: true },
);

const modalClosed = async () => {
  keepingModalOpening.value = false;
  displayCancelConfirmationModal.value = false;
  emit("modalClosed", false);
};

const cancelPromptDenied = () => {
  keepingModalOpening.value = true;
};

const onSaveClick = async () => {
  displayCancelConfirmationModal.value = false;
  emit("modalClosed", true, editableData.value);
  showModal.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalBase, {
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showModal).value = $event)),
    title: "Edit Room",
    onCancelPromptDenied: cancelPromptDenied,
    onModalClosed: modalClosed,
    showCloseConfirmationPrompt: displayCancelConfirmationModal.value
  }, {
    content: _withCtx(() => [
      _createVNode(FieldValidationFreeTextbox, {
        label: "Name",
        modelValue: editableData.value.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editableData.value.name) = $event)),
        height: "6rem"
      }, null, 8, ["modelValue"]),
      _createVNode(FieldValidationFreeTextArea, {
        label: "Description",
        modelValue: editableData.value.description,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editableData.value.description) = $event)),
        height: "6rem"
      }, null, 8, ["modelValue"]),
      (editableData.value.length !== null && editableData.value.width !== null)
        ? (_openBlock(), _createBlock(EditRoomMeasurements, {
            key: 0,
            "measurement-type": configMeasurementType.value,
            length: editableData.value.length,
            "onUpdate:length": _cache[2] || (_cache[2] = ($event: any) => ((editableData.value.length) = $event)),
            width: editableData.value.width,
            "onUpdate:width": _cache[3] || (_cache[3] = ($event: any) => ((editableData.value.width) = $event)),
            firstLabel: "Width",
            secondLabel: "Length",
            "display-suffix": false,
            formatData: formatMeasurements.value
          }, null, 8, ["measurement-type", "length", "width", "formatData"]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Save',
          onClick: () => {
            onSaveClick();
          },
          disabled: saving.value,
        }
      }, null, 8, ["options"]),
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Cancel',
          onClick: () => {
            onCancelClick();
          },
          disabled: saving.value,
        }
      }, null, 8, ["options"])
    ]),
    _: 1
  }, 8, ["modelValue", "showCloseConfirmationPrompt"]))
}
}

})